import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import { effortCss, effortColor } from '@/controllers/workspaces/persons/effort.controller'
import { EffortSummary, SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel'
import { EffortRmodel, Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel'
import TimelineComponent from '@/lib/forks/vue-cute-timeline/TimelineControl.vue'
import TimelineItem from '@/lib/forks/vue-cute-timeline/timelineItem.vue'
import dayjs from 'dayjs'
import { Direction, SegmentEnd } from '@/logic/_infra/_tech'
import { Timespending } from '@/app.context/workspace/Event'
import TimelineClocksComponent from './timeline/TimelineClocksComponent.vue'
import TimelineFullSubClocksComponent from './timeline/TimelineFullSubClocksComponent.vue'
import TimelineSimpleSubClocksComponent from './timeline/TimelineSimpleSubClocksComponent.vue'
import ZeroTimeffortComponent from './timeline/ZeroTimeffortComponent_Timeline.vue'

import TwitlightComponent from './timeline/TwitlightComponent_Timeline.vue'
import TimespendingComponent from './timeline/Timespending_Timeline.vue'
import EffortComponent from './timeline/EffortComponent_Timeline.vue'
import { useAppContext } from '@/app/_tech'
import { TimeSegment, minuteCalc } from '@/logic/_infra/time';
import TimesegmentComponent from '@/components/Workspaces/_infra/time/TimesegmentComponent.vue'
import TimelengthComponent from '@/components/Workspaces/_infra/time/TimelengthComponent.vue'

import EffortTextComponent from '@/components/Workspaces/persons/_spec/timeline/EffortTextComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EffortTimelineComponent',
  props: {
    model: {}
  },
  setup(__props: any) {

const props = __props


const context = useAppContext()

function click(d:Direction, e:SegmentEnd, effort:EffortRmodel, timeffort:Timeffort | null, timespending:Timespending | null){

    if (props.model!= null){


        const x =  props.model.summary.click(d,e, effort, timeffort, timespending)

        if (x.timespendings != null || x.tunes != null){

            const p = props.model.person

            const wid = p.workspace.wid

            if (x.tunes != null) context.storages.workspace!.personTimelineTunesUpdate(wid, p.nid, x.tunes)

            if (x.timespendings.length > 0 ) context.storages.workspace!.personTimespendingsUpdate(wid, p.nid, x.timespendings)
        }
    }

}


function iconType(x: EffortRmodel) {

    if (x.isTimespending()) return 'square'; else return 'default';
}

function iconSize(s: number): String {

    if (s == 0) return 'x-small';
    if (s == 1) return 'small';
    if (s == 2) return "medium";
    if (s == 3) return 'large';

    return 'x-large';
}


return (_ctx: any,_cache: any) => {
  return (_ctx.model != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TwitlightComponent, {
          efforts: _ctx.model.summary.twitlights.pre,
          onClick: click,
          offset: _ctx.model.offset
        }, null, 8, ["efforts", "offset"]),
        _createVNode(TimelineComponent, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.summary.timeline, (item, j) => {
              return (_openBlock(), _createBlock(TimelineItem, {
                key: j.toString() + JSON.stringify(_unref(effortCss)(item)),
                "bg-color": _unref(effortColor)(item),
                "icon-size": iconSize(item.size()),
                hollow: item.offhour == 'L' || item.timeffort?.effortType == 'I' || item.timeffort?.effortType == 'S'
              }, {
                default: _withCtx(() => [
                  (item.offhour != 'L')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(TimelineClocksComponent, {
                          item: item,
                          onClick: click,
                          offset: _ctx.model.offset
                        }, null, 8, ["item", "offset"]),
                        _createVNode(EffortComponent, {
                          item: item,
                          onClick: click,
                          offset: _ctx.model.offset
                        }, null, 8, ["item", "offset"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("   "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.timespendings, (s, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createVNode(TimelineFullSubClocksComponent, {
                              item: item,
                              segment: s.segment,
                              timeffort: null,
                              timespending: s.ref,
                              onClick: click,
                              offset: _ctx.model.offset
                            }, null, 8, ["item", "segment", "timespending", "offset"]),
                            _createTextVNode(),
                            _createVNode(TimespendingComponent, {
                              item: s.ref,
                              offset: _ctx.model.offset
                            }, null, 8, ["item", "offset"])
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.timefforts_zeros, (s) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: s[0].toString()
                          }, [
                            _createVNode(TimelineSimpleSubClocksComponent, {
                              item: item,
                              timepoint: s[0],
                              timeffort: s[1],
                              onClick: click,
                              offset: _ctx.model.offset
                            }, null, 8, ["item", "timepoint", "timeffort", "offset"]),
                            _createTextVNode(),
                            _createVNode(ZeroTimeffortComponent, {
                              item: s[1]
                            }, null, 8, ["item"])
                          ]))
                        }), 128))
                      ], 64))
                ]),
                _: 2
              }, 1032, ["bg-color", "icon-size", "hollow"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(TwitlightComponent, {
          efforts: _ctx.model.summary.twitlights.post,
          onClick: click,
          offset: _ctx.model.offset
        }, null, 8, ["efforts", "offset"]),
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.summary.mefforts, (m) => {
          return (_openBlock(), _createElementBlock("div", {
            key: m.meffort.mid.toString()
          }, [
            _createVNode(TimesegmentComponent, {
              segment: m.meffort.segment,
              offset: _ctx.model.offset
            }, null, 8, ["segment", "offset"]),
            _createTextVNode(),
            _createVNode(EffortTextComponent, {
              item: m.meffort.objects
            }, null, 8, ["item"])
          ]))
        }), 128)),
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.mefforts.simple, (item, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createTextVNode(_toDisplayString(_unref(minuteCalc).toAproximatedHoursString(item.minutes)) + " ", 1),
            _createVNode(TimelengthComponent, {
              minutes: item.minutes
            }, null, 8, ["minutes"]),
            _createTextVNode(),
            _createVNode(EffortTextComponent, {
              item: item.objects
            }, null, 8, ["item"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})